export const getFirstPermittedRoute = (permissions) => {
  const routeMap = {
    "Dashboard": "/dashboard",
    "Offer And Banner Management": "/offer-and-banner-management",
    "Category Management": "/category-management",
    "Product Management": "/product-management",
    "Reset Password": "/reset-password",
    "Profile": "/profile",
    "Settings": "/settings",
    "Dealer Management": "/dealer-management",
    "Customer Management": "/customer-management",
    "Order Management": "/order-management",
    "Report Management": "/report-management",
    "Delivery Partner Management": "/delivery-partner-management",
    "Payment Management": "/payment-management",
    "Notification Management": "/notification-management",
    "Subadmin Management": "/subadmin-management",
    "Rate & Review Management": "/rate-and-review-management",
    "Reports & Analytics Management": "/reports-and-analytics-management",
    "Dealer Commission Management": "/dealer-commission-management",
    "Language Management": "/language-management",
    "Currency Management": "/currency-management",
    "CMS Management": "/cms",
    "FAQ Management": "/faq",
    "Customer Query Management": "/customer-query-management",
    "Email Template Management": "/email-template",

    // add more if needed...
  };

  for (let key in routeMap) {
    if (permissions?.[key]) {
      return routeMap[key];
    }
  }

  return "/profile"; 
};
